import { Button, Col, Modal, Row, Pagination } from 'antd';
import info from '../assets/images/info.svg';
import AddIcon from '../assets/images/addIcon';
import MinusIcon from '../assets/images/minusIcon';
import React, { useState, useEffect } from 'react';
import { useGlobalState } from './GlobalState';

const ProductItem = ({ item, onIncrease, onDecrease }) => {
  const { name, quantity, max_quantity, price, description, image } = item;
  const [infoVisible, setInfoVisible] = useState(false);
  return (
    <>
      <Modal
        open={infoVisible}
        onCancel={() => setInfoVisible(false)}
        width={'min(95%, 30rem)'}
        title={null}
        footer={null}
        closable={false}
        maskClosable
        centered
      >
        <div className='px-20'>
          <div className='center mg-bottom-20'>
            {image && (
              <img
                style={{
                  maxWidth: '90%',
                  width: 140,
                  height: 90,
                  margin: '0.5rem auto -0.5rem',
                  objectFit: 'cover',
                }}
                alt='product-icon'
                className='br10'
                src={image}
              />
            )}
          </div>
          <div
            className='gSemiBold txt-center w-full fs-24'
            style={{ color: '#0D3759' }}
          >
            {name}
          </div>
          <div className='gMedium txt-center w-full fs-28 mg-bottom-15 sb-blue-700'>
            £{price.toFixed(2)}
          </div>
          <div className='gMedium txt-center w-full fs-16 mg-bottom-15 sb-blue-900'>
            {description}
          </div>
          <div className='display-flex-column'>
            <Button
              className='product-description-close-button fs-18 gSemiBold'
              onClick={() => setInfoVisible(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
      <Col span={24}>
        <Row justify='space-between' className='center flex-nowrap'>
          <Row className='flex-nowrap center'>
            {image ? (
              <img
                height={50}
                width={76}
                className='br10 mg-right-5'
                style={{ objectFit: 'cover' }}
                src={image}
                alt='product-add-on-icon'
              />
            ) : (
              <div className='product-add-on-no-image gSemiBold fs-12'>
                {' '}
                No Image
              </div>
            )}
            <div>
              <div className='fs-16 gSemiBold ' style={{ color: '#0D3759' }}>
                {name}
                {description && (
                  <img
                    src={info}
                    alt='info'
                    className='mg-left-5 cp'
                    onClick={() => setInfoVisible(true)}
                  />
                )}
              </div>
              <div className='fs-16 gMedium sb-blue-700'>
                £{price.toFixed(2)}
              </div>
            </div>
          </Row>
          <div>
            <Row
              className='center flex-nowrap'
              gutter={[25, 15]}
              style={{ alignItems: 'normal' }}
            >
              <Col className='center cp'>
                <button
                  onClick={onDecrease}
                  style={{
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                  }}
                  type='button'
                  disabled={quantity <= 0}
                >
                  <MinusIcon color={quantity <= 0 ? '#CCD3D9' : '#5C6166'} />
                </button>
              </Col>

              <div className='gRegular'>{quantity}</div>
              <Col className='center cp'>
                <button
                  onClick={onIncrease}
                  style={{
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                  }}
                  type='button'
                  disabled={max_quantity && quantity >= max_quantity}
                >
                  <AddIcon
                    color={
                      max_quantity
                        ? quantity >= max_quantity
                          ? '#CCD3D9'
                          : '#5C6166'
                        : '#5C6166'
                    }
                  />
                </button>
              </Col>
            </Row>
          </div>
        </Row>
      </Col>
    </>
  );
};

export default function ProductAddOn() {
  const [cartItems, setCartItems] = useGlobalState('productItem');

  const [addedItems, setAddedItems] = useGlobalState('addedProductItem');

  const [total, setTotal] = useState(0);

  useEffect(() => {
    const calculateTotal = () => {
      return addedItems
        .reduce((total, item) => total + item.quantity * (item.price || 0), 0)
        .toFixed(2);
    };

    setTotal(calculateTotal());
  }, [addedItems]);

  const handleIncrease = (itemId, quantity, maxQuantity) => {
    if (!maxQuantity || quantity < maxQuantity) {
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item.id === itemId ? { ...item, quantity: item.quantity + 1 } : item
        )
      );

      setAddedItems((prevAddedItems) => {
        const existingItem = prevAddedItems.find(
          (item) => item.product_id === itemId
        );

        if (existingItem) {
          return prevAddedItems.map((item) =>
            item.product_id === itemId
              ? {
                  ...(item?.name && { name: item?.name }),
                  ...(item?.price && { price: item?.price }),
                  product_id: item.product_id,

                  quantity: item.quantity + 1,
                }
              : item
          );
        } else {
          const newItem = cartItems.find((item) => item.id === itemId);
          return [
            ...prevAddedItems,
            {
              ...(newItem?.name && { name: newItem?.name }),
              ...(newItem?.price && { price: newItem?.price }),
              product_id: newItem?.id,
              quantity: 1,
            },
          ];
        }
      });
    }
  };

  const handleDecrease = (itemId, quantity) => {
    if (quantity > 0) {
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item.id === itemId && item.quantity > 0
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
      );

      setAddedItems((prevAddedItems) => {
        const existingItem = prevAddedItems.find(
          (item) => item.product_id === itemId
        );

        if (existingItem && existingItem.quantity > 1) {
          return prevAddedItems.map((item) =>
            item.product_id === itemId
              ? {
                  ...(item?.name && { name: item?.name }),
                  ...(item?.price && { price: item?.price }),
                  quantity: item.quantity - 1,
                  product_id: item.product_id,
                }
              : item
          );
        } else {
          return prevAddedItems.filter((item) => item.product_id !== itemId);
        }
      });
    }
  };
  const [currentPage, setCurrentPage] = useState(1);

  const onChangePagination = (page) => {
    setCurrentPage(page);
  };
  const startIndex = (currentPage - 1) * 5;
  const endIndex = startIndex + 5;

  return (
    <div
      style={{ borderBottom: '2px solid #DCE1E5' }}
      className='mg-bottom-20 w-full'
    >
      <div className='fs-20 gSemiBold mg-bottom-15'>
        Select your booking add-ons:
      </div>
      <Row gutter={[10, 15]}>
        {cartItems?.slice(startIndex, endIndex)?.map((item) => (
          <ProductItem
            key={item?.id}
            item={item}
            onIncrease={() =>
              handleIncrease(item.id, item.quantity, item.max_quantity)
            }
            onDecrease={() => handleDecrease(item.id, item.quantity)}
          />
        ))}
      </Row>
      <Pagination
        className='mg-top-30 mg-bottom-15'
        current={currentPage}
        onChange={onChangePagination}
        total={cartItems.length}
        pageSize={5}
        showSizeChanger={false}
      />
      <Row
        justify='end'
        className='fs-20 gSemiBold center mg-bottom-15'
        style={{ color: '#0D3759' }}
      >
        <span
          className='gMedium fs-16 mg-right-10'
          style={{ color: '#5C6166' }}
        >
          Total booking add-ons:
        </span>{' '}
        £{total}
      </Row>
      <Row
        justify='end'
        className=' gMedium center mg-bottom-5'
        style={{ color: '#A1AAB2' }}
      >
        Booking total will be updated at summary step
      </Row>
    </div>
  );
}
